import styled from 'styled-components';
import { TransparentContainer } from 'components/common/TransparentContainer';

export const IntroContainer = styled(TransparentContainer)`
    display: flex;
    align-items: stretch;
`;
